//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.12.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .factory('tableColumnTextFilterService', tableColumnTextFilterService);

    function tableColumnTextFilterService(sortService, MegaTableItemProperty) {

        let service = {};

        service.filter = data => {

            let filteredItems = data.unfilteredItems.slice();

            // Filter by text
            if (data.textItems) {
                filteredItems = filteredItems.filter(item => {
                    let textItem = data.textItems.find(textItem => textItem[data.columnKey] == item[data.columnKey]);
                    if (textItem)
                        return !textItem[MegaTableItemProperty.HIDDEN];
                    else
                        return true;
                });
            }

            // Filter by text
            if (data.searchText) {
                let searchText = data.searchText.toLowerCase();
                filteredItems = filteredItems.filter(item => item[data.columnKey] !== null && item[data.columnKey] !== undefined && item[data.columnKey].toString().toLowerCase().indexOf(searchText) > -1);
            }

            // Sort by direction
            if (data.column.sortDirection) {
                filteredItems = sortService.sortItemsByGenericDataType(filteredItems, data.columnKey, data.column.sortDirection);
            }

            data.itemsFiltered(filteredItems);
        };

        return service;
    }
})();